import React from 'react';
import { useTranslation } from 'react-i18next';
import './About.css';

const About = () => {
  const { t } = useTranslation();

  return (
    <section id="about" className="about">
      <div className="about-content">
        <h2 className="section-title" dangerouslySetInnerHTML={{ __html: t('about.title') }} />
        
        <div className="about-grid">
          <div className="about-text">
            <p className="about-description" dangerouslySetInnerHTML={{ __html: t('about.intro') }} />
            
            <p className="about-description" dangerouslySetInnerHTML={{ __html: t('about.expertise') }} />

            <div className="achievements">
              <h3 dangerouslySetInnerHTML={{ __html: t('about.research.title') }} />
              <ul className="achievement-list">
                {t('about.research.papers', { returnObjects: true }).map((paper, index) => (
                  <li key={index} dangerouslySetInnerHTML={{ __html: paper }} />
                ))}
              </ul>
            </div>

            <div className="certifications">
              <h3 dangerouslySetInnerHTML={{ __html: t('about.certifications.title') }} />
              <ul className="achievement-list">
                {t('about.certifications.list', { returnObjects: true }).map((cert, index) => (
                  <li key={index} dangerouslySetInnerHTML={{ __html: cert }} />
                ))}
              </ul>
            </div>
          </div>
          
          <div className="highlights-section">
            <h3 dangerouslySetInnerHTML={{ __html: t('about.highlights.title') }} />
            <ul className="highlights-list">
              {t('about.highlights.list', { returnObjects: true }).map((highlight, index) => (
                <li key={index}>
                  <span className="highlight-icon">{['🚀', '📚', '🌏', '💻', '🔍', '🎯'][index]}</span>
                  <span dangerouslySetInnerHTML={{ __html: highlight }} />
                </li>
              ))}
            </ul>

            <div className="skills-section">
              <h3 dangerouslySetInnerHTML={{ __html: t('about.technologies.title') }} />
              <ul className="tech-list">
                {t('about.technologies.list', { returnObjects: true }).map((tech, index) => (
                  <li key={index} dangerouslySetInnerHTML={{ __html: tech }} />
                ))}
              </ul>

              <h3 dangerouslySetInnerHTML={{ __html: t('about.softSkills.title') }} />
              <ul className="soft-skills-list">
                {t('about.softSkills.list', { returnObjects: true }).map((skill, index) => (
                  <li key={index} dangerouslySetInnerHTML={{ __html: skill }} />
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
